import {initializeApp} from "@firebase/app";
import {getMessaging, getToken, onMessage} from "@firebase/messaging";

(function () {
    XonBoard.Notifications = {
        handlePasswordProtectedAlarm: function (payload) {
            const notification = payload.notification;
            XonBoard.Alarms.notifyNow()

            const html = `<h5 style="color: white">${notification.title || ''}</h5><span>${notification.body || ''}</span>`;
            toastr.options = {
                onclick: function () {
                    const data = payload.data;

                    window.Livewire.dispatch('reload-notifications');
                    window.Alpine.store('passwordModal').show(data.url);
                }
            };
            toastr.error(html);
        },
        handlePasswordProtectedAlarmStopped: function (payload) {
            const data = payload.data;

            window.Alpine.store('notifications').removeAlarm(data.alarm_id);
        },
        handleNormalNotification: function (payload) {
            const notification = payload.notification;

            const html = `<h5>${notification.title || ''}</h5><span>${notification.body || ''}</span>`;
            toastr.info(html);
        },
        isPasswordProtectedAlarm: function (payload) {
            if (!payload || !payload.data || !payload.data.type) {
                return false;
            }

            return payload.data.type === 'password-protected'
        },
        isPasswordProtectedAlarmStopped: function (payload) {
            if (!payload || !payload.data || !payload.data.type) {
                return false;
            }

            return payload.data.type === 'password-protected-alarm-stopped'
        },
        onMessage: function (payload) {
            if (XonBoard.Notifications.isPasswordProtectedAlarm(payload)) {
                return XonBoard.Notifications.handlePasswordProtectedAlarm(payload);
            }

            if (XonBoard.Notifications.isPasswordProtectedAlarmStopped(payload)) {
                return XonBoard.Notifications.handlePasswordProtectedAlarmStopped(payload);
            }

            return XonBoard.Notifications.handleNormalNotification(payload);
        },
        initFcm: function (url) {
            // will be replaced by laravel-mix at build time
            const options = FIREBASE_OPTIONS_JSON;
            const firebaseApp = initializeApp(options);
            const messaging = getMessaging(firebaseApp);

            onMessage(messaging, XonBoard.Notifications.onMessage);

            getToken(messaging, {})
                .then((currentToken) => {
                    if (currentToken) {
                        let formData = new FormData();
                        formData.append('token', currentToken);

                        XonBoard.Utils.ajaxrequest(
                            url,
                            'post',
                            formData,
                            XonBoard.Utils.csrf,
                            {
                                success: function () {
                                },
                                error: function () {
                                },
                            }
                        );
                        return;
                    }
                    Notification.requestPermission();
                }).catch((err) => {
                console.log('An error occurred while retrieving token. ', err);
            });

        },
        listenBackgroundMessage(event) {
            XonBoard.Notifications.onMessage(event.data);
        },
        initBackgroundNotifications() {
            let sw = navigator.serviceWorker;

            if (sw.addEventListener) {
                sw.addEventListener("message", this.listenBackgroundMessage, false);
            } else {
                sw.attachEvent("onmessage", this.listenBackgroundMessage);
            }
        },
        init: function () {
            this.initBackgroundNotifications();
            this.initPasswordForm();
        },
        // Separate from init() so the stop-alarm dialog submits over AJAX (toast, errors in the dialog)
        // while the FCM background listener stays disabled.
        initPasswordForm: function () {
            var modal = $('#password-modal');

            $("#password-form").submit(function (e) {
                e.preventDefault();
                $(".submit-button").prop('disabled', 'disabled');

                $("#password-form").ajaxSubmit({
                    success: function (data) {
                        XonBoard.Utils.handleSuccess(data.flash_success);
                        modal.find('.validation-errors').empty();
                        modal.find('form').trigger('reset');
                        modal.modal('hide');
                        $(".submit-button").prop("disabled", false);

                        window.Livewire.dispatch('reload-notifications');
                    },
                    error: function (xhr, status, data) {
                        XonBoard.Utils.handleError(xhr, data)
                        $(".submit-button").prop("disabled", false);
                    }
                });
            });
        },
    };
}());
